import React from 'react';
import {HelmetProvider} from 'react-helmet-async';
import {Provider} from 'react-redux';

import store from '../store';
import App from '../App';

export function Root() {
  return (
    <React.StrictMode>
      <HelmetProvider>
        <Provider store={store}>
          <App />
        </Provider>
      </HelmetProvider>
    </React.StrictMode>
  );
}
